module.exports = __webpack_public_path__ + "static/media/menu_terms&conditions_default.ff02c9ad.svg";